import { toast } from "@/components/toast"

interface InviteError {
	message?: string
	data?: { code?: string } | null
}

// A seat cap or a role gate is a blocked action the admin can fix, so it gets the neutral toast instead of red.
const GUARD_CODES = new Set([
	"BAD_REQUEST",
	"CONFLICT",
	"FORBIDDEN",
	"TOO_MANY_REQUESTS",
])

export function showInviteErrorToast(error: InviteError) {
	const code = error.data?.code
	const message = error.message?.trim()

	if (code && GUARD_CODES.has(code) && message) {
		toast.info({
			title: "Couldn't send the invite",
			description: message || "Try again in a moment.",
		})
		return
	}

	toast.error({
		title: "Couldn't send the invite",
		description: message || "Try again in a moment.",
	})
}
